import { shouldValidateOpgavekompleksetInput, getValidatableOpgavekompleksetInputs, validateOpgavekompleksetInput } from '@utils/component-framework';
import { useOpgavekompleksetComponent } from '../../state/context.data.js';
import { useOpgavekompleksetEntry } from '../../state/hook.entry.js';
import { useTaskContext, useTaskMeta } from './context.js';

function useInputState(node, inputEntry, options) {
  const context = useTaskContext();
  const meta = useTaskMeta();
  const component = useOpgavekompleksetComponent();
  const taskEntry = useOpgavekompleksetEntry({
    select: entry => entry?.data.tasks[meta.taskEntryKey]
  });
  if (context === "input") {
    return "input";
  }
  if (context === "readonly") {
    return "readonly";
  }
  if (!options?.forceValidation?.(node, inputEntry) && !shouldValidateOpgavekompleksetInput(node, inputEntry)) {
    return "readonly";
  }
  const validatableInputs = getValidatableOpgavekompleksetInputs(component.data, meta.taskEntryKey, taskEntry);
  const nodeInputPairs = validatableInputs.map(input => ({
    node: input,
    entry: taskEntry?.details[input.id]
  }));
  if (validateOpgavekompleksetInput(node, inputEntry, {
    inputs: nodeInputPairs
  })) {
    return "correct";
  } else {
    return "incorrect";
  }
}

export { useInputState };
//# sourceMappingURL=hook.use-input-state.js.map
